import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, InputNumber, Row, Select, Space, Table, Tabs, Tag, Tooltip, message } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { LuArrowDownUp } from "react-icons/lu";
import dayjs from 'dayjs';
import EditableTable from '../../../globalComponents/EditableTable';
import { detailedOperationColumns, operationColumns } from '../../utils/TableColumns';
import DetailedOperationModal from '../../modals/DetailedOperationModal';
import StatusComponent from '../../../globalComponents/StatusComponent';
import EventEmitter from '../../../utils/eventEmitter';
import useStockRequestAPI from '../../apis/stockRequestAPI';
import SmartButton from '../../../globalComponents/SmartButton';
import AuthContext from '../../../utils/AuthContext';


const shippingPolicies = [
  {value: '', label: ''},
  {value: 'asap', label: 'As soon as possible'},
  {value: 'all_at_once', label: 'When all product are ready'}
]


const columns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '60%'
  },
  {
    title: 'Demand',
    dataIndex: 'demand_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Done',
    dataIndex: 'done_quantity',
    editable: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Action',
    width: '15%'
  }
]


const StockRequestChanges = () => {
  const [form] = Form.useForm();
  const { user } = useContext(AuthContext);
  const { stockRequest, products, locations, operation_types } = useLoaderData();
  stockRequest['request_date'] = stockRequest.request_date ? dayjs(stockRequest['request_date'], 'YYYY-MM-DD HH:MM') : '';
  stockRequest['done_date'] = stockRequest.done_date ? dayjs(stockRequest['done_date'], 'YYYY-MM-DD HH:MM') : '';
  const params = useParams();
  const navigate = useNavigate();
  const { create, update, sendTransferRequest, removeRequestLine } = useStockRequestAPI();
  const [stockLines, setStockLines] = useState(stockRequest.inv_stockrequestlines ? stockRequest.inv_stockrequestlines : []);
  console.log(stockRequest);
  // if (stockRequest.number) {
  //   const route = routes.find(obj => obj.id === stockRequest.route_id);
  //   form.setFieldValue('location_src_id', route.loc_src);
  //   form.setFieldValue('location_dest_id', route.loc_dest);
  // }

  const onChangeRoute = option => {
    delete option.value;
    delete option.label;
    form.setFieldValue('location_src_id', option.loc_src);
    form.setFieldValue('location_dest_id', option.loc_dest);
  };


  
  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['stocklines'] = stockLines;
    data['request_date'] = new Date(data.request_date).toISOString();
    data.created_by = user.id;
    await create(data);
    console.log(data)
  }

  const sendStockRequest = async () => {
    try {
      let data = {};
      data['status'] = 'stock_request';
      data['id'] = stockRequest.id;
      data['stocklines'] = stockLines;
      data['location_src_id'] = form.getFieldValue('location_src_id');
      // data['request_date'] = new Date(data.request_date).toISOString();
      // console.log(data);
      data.created_by = user.id;
      await update(stockRequest.number.replaceAll('/', '-'), data);
    }catch (err) {
      console.log(err);
    }
  }

  const proceedStockTransfer = () => {
    let data = {};
    data['operation_type_id'] = form.getFieldValue('operation_type_id');
    data['stocklines'] = stockLines;
    data['request_date'] = form.getFieldValue('request_date');
    data['number'] = stockRequest.number;
    
    data['location_src_id'] = form.getFieldValue('location_src_id');
    data['location_dest_id'] = form.getFieldValue('location_dest_id');
    sendTransferRequest(data);
  }

  useEffect(() => {
    EventEmitter.subscribe('stock_request_response', data => {
      navigate('/inventory/stock-request/'+data.replaceAll('/', '-'));
    });    
    return () => {
      EventEmitter.unsubscribe('stock_request_response');
    }
  },[]);


  const addLine = () => { 
    let array = [...stockLines];
    let obj = {
      key: stockLines.length,
      product_id: '',
      done_quantity: 0,
      demand_quantity: 0,
    };
    array.push(obj);
    setStockLines(array);
  };


  
  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/stock-request/'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Stock Request</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ stockRequest.number ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {stockRequest.number && 
        <div className='flex justify-between bg-white'>
          <Flex wrap='wrap' align='center' gap={'small'} style={{maxWidth: '70%'}}>
            {/* <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn'>VALIDATE</Button>
            <Button size='small' type='text' className='font-semibold text-[#189aa0]' onClick={setQuantities}>SET QUANTITIES</Button>
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>PRINT</Button> */}
            {stockRequest.status === 'draft' && <Button size='small' type='primary' onClick={sendStockRequest} className='font-semibold bg-[#189aa0] hover-btn'>STOCK REQUEST</Button>}
            {stockRequest.status === 'stock_request' && <Button size='small' type='primary' onClick={proceedStockTransfer} className='font-semibold bg-[#189aa0] hover-btn'>PROCEED TO TRANSFERS</Button>}
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>CLEAR</Button>
          </Flex>
          <StatusComponent formValue={stockRequest} name={'STOCK_REQUEST'}/>
        </div>
        }
        
      </div>
      <div className='mt-5 bg-white shadow'>
        {(stockRequest.status === 'request_in_progress' || stockRequest.status === 'done') && 
          <Flex className='border-b m-0' justify='flex-end'>
            <SmartButton icon={<LuArrowDownUp size={'1.4rem'} />} number={'Internal'} text={'Transfer'} to={`/inventory/stock-request/${params.action}/transfers`} className='border-s-2'/>
          </Flex>
        }
        <Form 
          form={form}
          labelAlign='left'
          className='p-3'
          labelCol={{span: 9}}
          initialValues={stockRequest.number ? stockRequest :
            {
              location_src_id: '', 
              location_dest_id: '', 
              request_date: dayjs()
            }
          }
          variant='borderless'
          disabled = {(stockRequest.status !== 'draft' && stockRequest.status !== undefined) ? true : false}
        >
          {/* <Badge className="text-slate-500 text-md bg-transparent	border-b-2">Simulatneous Conditions To Met</Badge> */}
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label={'Created By'} className='font-bold mb-1' required>
                <Input type='text' readOnly value={user.user} className='font-normal input-outline-none' />
              </Form.Item>
              <Form.Item label='Operation Type' name={'operation_type_id'} className='font-bold mb-1' required>
                <Select disabled={stockRequest.number ? true : false} options={operation_types.map(operation_type => ({value: operation_type.id, label: operation_type.name, loc_src: operation_type.source_location, loc_dest: operation_type.destination_location}))} onChange={(v, option) => onChangeRoute(option)} className='font-normal' />
              </Form.Item>
              <Form.Item label='Source Location' name={'location_src_id'} className='font-bold mb-1' required>
                <Select disabled={true} options={locations.map(location => ({value: location.id, label: `${location.name}`}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Destination Location' name={'location_dest_id'} className='font-bold mb-1' required>
                <Select disabled={stockRequest.number ? true : false} options={locations.map(location => ({value: location.id, label: `${location.name}`}))}  className='font-normal' />
              </Form.Item>
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Request Date' name={'request_date'} className='font-bold mb-1' required>
                <DatePicker showTime disabled format={'YYYY-MM-DD HH:mm'} className='font-normal'/>
              </Form.Item>
              <Form.Item label='Done Date' name={'done_date'} className='font-bold mb-1' required>
                <DatePicker showTime disabled format={'YYYY-MM-DD HH:mm'} className='font-normal'/>
              </Form.Item>
            </Col>
          </Row>
          <Tabs 
            className='mt-5'  
            type='card'
            items={[
              {
                key: 1,
                label: 'Products',
                children: 
                <EditableTable
                  name={'transfer'}
                  dataSource={stockLines}
                  setDataSource={setStockLines}
                  addLine={addLine}
                  columns={columns}
                  products={products}
                  apiDelete={removeRequestLine}
                />
              },
              {
                key: 2,
                label: 'Notes',
                forceRender: true,
                children: 
                <Form.Item name={'note'} className='font-bold mb-1' required>
                  <Input className='input-outline-none font-normal' placeholder='Add an internal note that will be printed at the Picking Operations sheets' />
                </Form.Item>
              }
            ]}
          />          
        </Form>
      </div>
      <DetailedOperationModal />
    </div>
  )
}
export default StockRequestChanges;